
import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';

import { DateFilter } from '../app.model';
import { apiConstant } from 'src/app/app.constant';
import { ReportService } from '../services/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payroll-report',
  templateUrl: './payroll-report.component.html',
  styleUrls: ['./payroll-report.component.css']
})

export class PayrollReportComponent implements OnInit {

  @ViewChild('picker', { static: true }) _picker!: MatDatepicker<Date | any>;

  error!: string;
  loading: boolean = false;
  payBillReportData: any = [];
  payBillReportDates: any = [];
  trackHours: any = 0;
  payBillSearchForm: FormGroup | any;
  reportType: string = 'general_report';
  exportOpen: boolean = false;

  public start_date: any
  public end_date: any
  public custom_datepicker_text: string = "Custome Date picker";
  public filterOptions: any = this.reportService.filterDateRangePickerOptions;
  public selectedFilterOption: any = this.filterOptions[3].label;

  public API_CONSTANT = apiConstant;
  public currencyFormat: any;

  constructor(private reportService: ReportService, private datePipe: DatePipe,) {
    this.setStartEndDate()
  }

  ngOnInit(): void {
    this.currencyFormat = localStorage.getItem('currencyFormat') ? localStorage.getItem('currencyFormat') : '';
    this.FormGroupUpdate();
    this.onSubmit();
  }

  FormGroupUpdate() {
    this.payBillSearchForm = new FormGroup({
      candidate_uuid: new FormControl(''),
      start_date: new FormControl(new Date(this.start_date), Validators.required),
      end_date: new FormControl(new Date(this.end_date), Validators.required),
      export_type: new FormControl(''),
      report_type: new FormControl('general_report'),
    });
  }

  public DatepcikerEndDateChanged(event: MatDatepickerInputEvent<Date>): void {
    let start_date = this.datePipe.transform(this.payBillSearchForm.value.start_date, 'yyyy-MM-dd');
    let end_date = this.datePipe.transform(this.payBillSearchForm.value.end_date, 'yyyy-MM-dd');

    if (start_date && end_date) {
      this.custom_datepicker_text = `${start_date} - ${end_date}`;
      this.selectedFilterOption = `${start_date} - ${end_date}`;
    }
  }

  onFilterChange(picker: any) {
    if (this.selectedFilterOption === 'datePicker') {
      picker.open();
    } else {
      this.setStartEndDate()
      this.FormGroupUpdate()
    }
  }

  setStartEndDate() {
    const selectedFilter: DateFilter = this.filterOptions.find((x: DateFilter) => x.label === this.selectedFilterOption);
    if (selectedFilter.start_date != '' && selectedFilter.end_date != '') {
      this.start_date = selectedFilter.start_date;
      this.end_date = selectedFilter.end_date;
    }
  }

  setReportType(value: string) {
    this.reportType = value;
    this.payBillSearchForm.get('report_type')?.setValue(value);
  }

  async onSubmit() {
    this.error = '';
    this.loading = true;

    const payload = {
      ...this.payBillSearchForm.value,
      start_date: this.datePipe.transform(this.payBillSearchForm.value.start_date, 'yyyy-MM-dd'),
      end_date: this.datePipe.transform(this.payBillSearchForm.value.end_date, 'yyyy-MM-dd'),
      export_type: '',
      type: 'pay',
    };

    this.reportService.getPayBillReportData(payload).subscribe((response) => {
      this.payBillReportData = response.report_data;
      this.payBillReportDates = response.report_days;
      this.trackHours = response.track_hours;
      this.loading = false;
      this.error = '';
    }, error => {
      this.loading = false;
      this.error = error;
    });
  }

  toggleExport(evt: Event) {
    evt.stopPropagation();
    this.exportOpen = !this.exportOpen;
  }

  onExport(type: string) {
    this.exportOpen = false;
    this.exportIn(type);
  }

  exportIn(exportType: string) {
    this.error = '';
    this.loading = true;
    const payload = {
      ...this.payBillSearchForm.value,
      start_date: this.datePipe.transform(this.payBillSearchForm.value.start_date, 'yyyy-MM-dd'),
      end_date: this.datePipe.transform(this.payBillSearchForm.value.end_date, 'yyyy-MM-dd'),
      export: true,
      export_type: exportType,
      type: 'pay'
    };
    this.reportService.getPayBillReportDataExport(payload).subscribe((response: any) => {
      window.open(environment.baseUrl.replace('api/', '') + response.report_path, '_blank');
      this.loading = false;
    }, error => {
      this.loading = false;
      this.error = error;
    });
  }

  onSearchChange(event: any) {
    this.payBillSearchForm.patchValue({
      [event.formControlName]: event.value.uuid
    })
    this.onSubmit();
  }

  selectedReportType(event: any) {
    this.reportType = event.value;
  }

  maxLimit() {
    return this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  }

  // KPI strip totals — computed off payBillReportData
  get totalContractors(): number { return this.payBillReportData?.length || 0; }
  get totalHours(): number {
    if (!this.payBillReportData?.length) return 0;
    const key = this.trackHours == 2 ? 'total_days' : 'total_hours';
    return this.payBillReportData.reduce((acc: number, r: any) => acc + (Number(r?.[key]) || 0), 0);
  }
  get totalRegular(): number {
    return (this.payBillReportData || []).reduce((a: number, r: any) => a + (Number(r?.regular_hours) || 0), 0);
  }
  get totalOt(): number {
    return (this.payBillReportData || []).reduce((a: number, r: any) => a + (Number(r?.ot_hours) || 0), 0);
  }
  get totalDoubleOt(): number {
    return (this.payBillReportData || []).reduce((a: number, r: any) => a + (Number(r?.double_ot_hours) || 0), 0);
  }
  get totalMoney(): number {
    return (this.payBillReportData || []).reduce((a: number, r: any) => a + (Number(r?.total_pay) || 0), 0);
  }

  initialsOf(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
  }

  statusClass(status: string): string {
    const s = (status || '').toLowerCase();
    if (s === 'approved') return 'approved';
    if (s === 'submitted') return 'submitted';
    if (s === 'pending') return 'pending';
    if (s === 'rejected') return 'rejected';
    return 'submitted';
  }
  statusIcon(status: string): string {
    const s = (status || '').toLowerCase();
    if (s === 'approved') return 'bi-check-circle-fill';
    if (s === 'submitted') return 'bi-record-circle-fill';
    if (s === 'pending') return 'bi-stopwatch-fill';
    if (s === 'rejected') return 'bi-x-circle-fill';
    return 'bi-record-circle-fill';
  }

  @HostListener('document:click')
  closeExportOnOutsideClick() {
    if (this.exportOpen) this.exportOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeExportOnEsc() {
    this.exportOpen = false;
  }
}
